module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_6_CIUDADANO.80dbc0df.jpg";